import {FETCH_USER_REPORT} from "../../actions/actionTypes"

const initialState = {  
    data: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    
    switch (action.type) {    
        case FETCH_USER_REPORT.REQUEST:
            return {...state,loading: true}
        case FETCH_USER_REPORT.FAILURE:
            return {...state, loading: false}
        case FETCH_USER_REPORT.SUCCESS:             
            return {...state, data: action.obj, loading: false}    
        default:
            return state
    }
}

export default reducer;